// extracted by mini-css-extract-plugin
export default {"tableHeaderMargin":"TableHeader_tableHeaderMargin__GFZry","controls":"TableHeader_controls__tU05d","downloadIcon":"TableHeader_downloadIcon__kc58Z"};